// @flow
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';

import NumberUtils from 'common/utils/NumberUtils';
import EnvConfig from 'config';

import ErrorReporter from 'common/utils/ErrorReporter';

import { type I18nStrings } from './types';

export const defaultI18nOptions = {
    fallbackLng: 'en-US',
    ns: ['translations'],
    defaultNS: 'translations',
    fallbackNS: 'translations',
    returnEmptyString: true,
    returnNull: true,
    debug: EnvConfig.env === 'local',
    saveMissing: true,
    missingKeyHandler: (
        language,
        namespace,
        key,
        fallbackValue,
        updateMissing,
        options
    ) => {
        const metadata = {
            language,
            namespace,
            translationKey: key,
            fallbackValue
        };
        const errorMessage = `Key missing for: ${key} in namespace: ${namespace}`;
        ErrorReporter.notify(new Error(errorMessage), {
            errorName: errorMessage,
            product: options.product,
            metadata
        });
    },
    /*
        wait: false is the default, but explicitely mentioning because setting it to true
        would cause the PopOver positioning to break.
        ref: https://github.com/i18next/react-i18next/issues/324
    */
    react: {
        wait: false,
        withRef: true,
        defaultTransParent: 'div',
        useSuspense: false
    },
    interpolation: {
        escapeValue: false,
        format: (value, format) => {
            switch (format) {
                case 'pad':
                    return NumberUtils.padLeft(value);
                case 'lowercase':
                    return value.toLowerCase();
                case 'uppercase':
                    return value.toUpperCase();
            }
        }
    }
};

const createInstance = (strings: I18nStrings): $FixMe => {
    const i18n = i18next.createInstance();

    i18n.use(initReactI18next)
        .use(intervalPlural)
        .init({
            ...defaultI18nOptions,
            resources: {
                'en-US': strings
            }
        });

    return i18n;
};

export default createInstance;
